/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AdditionalCostsCategoryDto } from '../../models/additional-costs-category-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetAdditionalCostsCategoryList$Params {}

export function getAdditionalCostsCategoryList(
  http: HttpClient,
  rootUrl: string,
  params?: GetAdditionalCostsCategoryList$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AdditionalCostsCategoryDto>>> {
  const rb = new RequestBuilder(rootUrl, getAdditionalCostsCategoryList.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AdditionalCostsCategoryDto>>;
    }),
  );
}

getAdditionalCostsCategoryList.PATH = '/service/v1/afterSales/additionalCostsCategory';
